import { HpDispatchFunction } from './actionTypes';

export function clearPaymentSuccessAction() {
  return (dispatch: HpDispatchFunction<void>): void => {
    dispatch({
      type: 'CLEAR_PAYMENT_SUCCESS'
    });
  };
}
